@if (activated.loginPage) {

  <!-- Authentication Layout -->
  <div class="auth-view">
    <router-outlet></router-outlet>
  </div>

} @else {

  <!-- Application Shell -->
  <div
    class="app-shell"
    [class.sidebar-collapsed]="isSidebarCollapsed && !isMobile"
    [class.mobile-sidebar-open]="isMobileSidebarOpen && isMobile"
  >

    <!-- Sidebar -->
    <app-sidebar
      id="app-sidebar"
      [collapsed]="isSidebarCollapsed"
      [mobileOpen]="isMobileSidebarOpen"
      [isMobile]="isMobile"
      (collapseChange)="toggleSidebar()"
      (closeMobile)="closeMobileSidebar()"
    ></app-sidebar>

    <!-- Mobile Overlay -->
    @if (isMobile && isMobileSidebarOpen) {
      <button
        type="button"
        class="sidebar-overlay"
        aria-label="Close navigation menu"
        (click)="closeMobileSidebar()"
      ></button>
    }

    <!-- Main Content -->
    <main class="main-area">

      <!-- Mobile Menu Button -->
      @if (isMobile) {
        <button
          type="button"
          class="mobile-menu-button"
          aria-label="Toggle navigation menu"
          aria-controls="app-sidebar"
          [attr.aria-expanded]="isMobileSidebarOpen"
          (click)="toggleMobileSidebar()"
        >
          <i class="bi bi-list" aria-hidden="true"></i>
        </button>
      }

      <!-- Page Content -->
      <section class="page-content">
        <router-outlet></router-outlet>
      </section>

    </main>

  </div>
}

<!-- Global Components -->
<app-alert></app-alert>
<app-loader></app-loader>